import { useState } from "react";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import LandingSectionHeader from "./LandingSectionHeader";
import LandingEditorScreenshot from "./LandingEditorScreenshot";
import { CREATION_FORMATS } from "./landingCreationFormats";
import "./LandingProductsTabs.css";
import "./LandingCreationSection.css";

const PRODUCTS = [
  {
    id: "knowledge_base",
    icon: <MenuBookOutlinedIcon />,
    name: "База знаний",
    accent: "kb",
    tagline: "Ответ на рабочий вопрос за секунду — прямо на объекте или смене",
    points: [
      "Темы, подтемы и пары «вопрос — ответ» текстом или видео",
      "Сотрудник открывает бота и находит подсказку без звонка наставнику",
    ],
  },
  {
    id: "scenario",
    icon: <AccountTreeOutlinedIcon />,
    name: "Сценарий",
    accent: "scenario",
    tagline: "Интерактивное обучение: каждый выбор меняет ход программы",
    points: [
      "Карта сцен с видео и кнопками выбора — как в реальной ситуации",
      "Подходит для онбординга, продаж, сервиса и отработки кейсов",
    ],
  },
  {
    id: "trainer",
    icon: <QuizOutlinedIcon />,
    name: "Тренажёр",
    accent: "trainer",
    tagline: "Проверка знаний, рейтинг и мотивация в игровой форме",
    points: [
      "Вопросы с вариантами ответов — HR видит результат по команде",
      "Рейтинг и ачивки: акции вроде «первое место за месяц — приз»",
    ],
  },
];

const botPreviews = Object.fromEntries(
  CREATION_FORMATS.map((format) => [format.id, format.bot])
);

export default function LandingProductsTabs() {
  const [activeId, setActiveId] = useState(PRODUCTS[0].id);
  const active = PRODUCTS.find((p) => p.id === activeId) ?? PRODUCTS[0];
  const botPreview = botPreviews[active.id];

  return (
    <section
      id="products"
      className="landing-band landing-band--products-detail landing-section landing-section--products-detail"
    >
      <div className="landing-container">
        <LandingSectionHeader
          label="03 · Интерфейс"
          title="Как это выглядит внутри"
          desc="Три редактора для HR — переключайте вкладки и смотрите экраны базы знаний, сценария и тренажёра."
        />

        <div className="landing-products-tabs">
          <div className="landing-products-tabs__nav landing-products-tabs__nav--compact" role="tablist">
            {PRODUCTS.map(({ id, icon, name, accent, tagline }) => (
              <button
                key={id}
                type="button"
                role="tab"
                aria-selected={activeId === id}
                className={`landing-products-tabs__tab landing-products-tabs__tab--${accent}${
                  activeId === id ? " landing-products-tabs__tab--active" : ""
                }`}
                onClick={() => setActiveId(id)}
              >
                <span className="landing-products-tabs__tab-icon">{icon}</span>
                <span className="landing-products-tabs__tab-name">{name}</span>
                <span className="landing-products-tabs__tab-tagline">{tagline}</span>
              </button>
            ))}
          </div>

          <article className="landing-products-tabs__visual" role="tabpanel">
            <div className="landing-products-tabs__shot">
              <LandingEditorScreenshot type={active.id} />
            </div>
            <aside className="landing-products-tabs__aside">
              <ul className="landing-products-tabs__points">
                {active.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
              {botPreview ? (
                <div className="landing-products-tabs__bot">
                  <span className="landing-products-tabs__bot-label">
                    Как видит сотрудник в боте
                  </span>
                  {botPreview}
                </div>
              ) : null}
            </aside>
          </article>
        </div>
      </div>
    </section>
  );
}
